/* ICON WRAPPER — EVERY ICON INHERITS THE CURRENT TEXT COLOR */
const Icon = ({ size = 16, width = 2, children }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth={width} strokeLinecap="round" strokeLinejoin="round">
        {children}
    </svg>
)


/* CLOSE ICON */
export const CloseIcon = ({ size }) => (
    <Icon size={size}>
        <path d="M18 6 6 18M6 6l12 12" />
    </Icon>
)

/* CHECK ICON */
export const CheckIcon = ({ size = 12 }) => (
    <Icon size={size} width={3.5}>
        <path d="M20 6 9 17l-5-5" />
    </Icon>
)

/* SEARCH ICON */
export const SearchIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="10.8" cy="10.8" r="6.8" />
        <path d="M20.5 20.5 15.7 15.7" />
    </Icon>
)

/* FILTER ICON — THE PERIOD, THE OPERATORS AND THE GAMES OF THE LIST */
export const FilterIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M3 6h18M6.5 12h11M10 18h4" />
    </Icon>
)

/* EYE ICON — THE TRANSACTION OPENS IN A MODAL */
export const EyeIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
        <circle cx="12" cy="12" r="3" />
    </Icon>
)

/* COPY ICON — THE NUMBER OF A TRANSACTION GOES TO THE CLIPBOARD */
export const CopyIcon = ({ size = 14 }) => (
    <Icon size={size}>
        <rect x="9" y="9" width="11" height="11" rx="2.5" />
        <path d="M15 5.5A2.5 2.5 0 0 0 12.5 3H6.5A2.5 2.5 0 0 0 4 5.5v6A2.5 2.5 0 0 0 6.5 14" />
    </Icon>
)

/* WALLET ICON — THE SECTION ITSELF */
export const WalletIcon = ({ size = 20 }) => (
    <Icon size={size}>
        <path d="M3.5 7.5A2.5 2.5 0 0 1 6 5h11.5A2.5 2.5 0 0 1 20 7.5v9a2.5 2.5 0 0 1-2.5 2.5H6a2.5 2.5 0 0 1-2.5-2.5Z" />
        <path d="M3.5 9.5h13a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-13" />
        <path d="M15.4 12h.2" />
    </Icon>
)

/* PLAYER ICON — HOW MANY PEOPLE STAND BEHIND THE ROWS */
export const PlayerIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="9" cy="8" r="3.6" />
        <path d="M2.8 19.5c0-3.2 2.8-5.2 6.2-5.2s6.2 2 6.2 5.2" />
        <path d="M16.5 5.2a3.4 3.4 0 0 1 0 6.6M18 14.7c2.1.6 3.4 2.2 3.4 4.3" />
    </Icon>
)

/* VIP ICON — A CROWN, THE PLAYER IS MARKED IN Users */
export const VipIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M3 7.5 6.5 11 12 4.5 17.5 11 21 7.5v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" />
    </Icon>
)

/* ALERT ICON — A TRANSACTION THE OPERATOR REFUSED */
export const AlertIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 3.5 21.5 20H2.5Z" />
        <path d="M12 10v4.5M12 17.4v.6" />
    </Icon>
)

/* REFUND ICON — THE MONEY WENT BACK */
export const RefundIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M4 9.5h10.5a4.5 4.5 0 0 1 0 9H9" />
        <path d="M7.5 6 4 9.5 7.5 13" />
    </Icon>
)

/* DEBIT ICON — THE MONEY LEFT THE PLAYER */
export const DebitIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 4.5v13" />
        <path d="M7 12.5 12 17.5 17 12.5" />
    </Icon>
)

/* CREDIT ICON — THE MONEY CAME BACK TO THE PLAYER */
export const CreditIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 19.5v-13" />
        <path d="M7 11.5 12 6.5 17 11.5" />
    </Icon>
)

/* NET ICON — THE DIFFERENCE BETWEEN THE TWO */
export const NetIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M3.5 17.5 9 11l4 4 7.5-8.5" />
        <path d="M15.5 6.5h5v5" />
    </Icon>
)

/* TABLE ICON — THE GAME BEHIND A TRANSACTION */
export const TableIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="2.5" y="4.5" width="19" height="12" rx="4" />
        <path d="M8 20h8M12 16.5V20" />
    </Icon>
)

/* STUDIO ICON — THE GROUP OF A TABLE */
export const StudioIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3" y="4.5" width="18" height="12.5" rx="2.5" />
        <path d="M7 21h10M12 17v4" />
    </Icon>
)

/* OPERATOR ICON — WHO ASKED FOR THE MONEY */
export const OperatorIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M4 20.5V6.5A2 2 0 0 1 6 4.5h6a2 2 0 0 1 2 2v14" />
        <path d="M14 10.5h4a2 2 0 0 1 2 2v8" />
        <path d="M2.5 20.5h19M7.5 8.5h3M7.5 12.5h3M7.5 16.5h3" />
    </Icon>
)

/* CALENDAR ICON — THE PERIOD OF THE LIST */
export const CalendarIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <rect x="3.5" y="5" width="17" height="15.5" rx="3" />
        <path d="M3.5 10h17M8.5 3v4M15.5 3v4" />
    </Icon>
)

/* CLOCK ICON — THE MOMENT OF A TRANSACTION */
export const ClockIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M12 7.5V12l3.5 2" />
    </Icon>
)

/* INFO ICON — THE HINT OF A SECTION */
export const InfoIcon = ({ size = 16 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v5M12 7.6v.6" />
    </Icon>
)

/* HASH ICON — THE NUMBER OF A TRANSACTION */
export const HashIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M9.5 3.5 7.5 20.5M16.5 3.5l-2 17M4 8.5h16M3 15.5h16" />
    </Icon>
)

/* LAYERS ICON — HOW MANY ROWS THE FILTER HOLDS */
export const LayersIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 3 21 8l-9 5-9-5Z" />
        <path d="M3 13.5l9 5 9-5" />
    </Icon>
)

/* STATUS ICON — WHAT THE OPERATOR ANSWERED */
export const StatusIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <circle cx="12" cy="12" r="8.5" />
        <path d="M8.5 12.3 11 14.8l4.5-5" />
    </Icon>
)

/* BALANCE ICON — THE WALLET OF THE PLAYER BEFORE AND AFTER */
export const BalanceIcon = ({ size = 13 }) => (
    <Icon size={size}>
        <path d="M12 4.5v15" />
        <path d="M6.5 8.5h8a2.5 2.5 0 0 1 0 5h-5a2.5 2.5 0 0 0 0 5h8" />
    </Icon>
)
